import React, { FC } from 'react';
import classNames from 'classnames';

import { Badge, LuvImage } from '@/components';
import { TypeSideImageCardFields } from '@/core/generated-types';
import Heading, {
  HeadingSize,
  HeadingTag,
} from '@/components/ui/Heading/Heading';

interface SideImageCardProps extends TypeSideImageCardFields {
  isSingleItem?: boolean;
}

const SideImageCard: FC<SideImageCardProps> = ({
  badge,
  title,
  description,
  mobileImage,
  desktopImage,
  isSingleItem,
}) => {
  return (
    <div
      className={classNames(
        'lg:max-h-[400px] lg:flex lg:w-full text-charcoal',
        {
          'lg:mx-9': isSingleItem,
        },
      )}
      data-testid="side-image-card"
    >
      {/* Mobile image */}
      <div className="block lg:hidden">
        <LuvImage
          className="w-full h-full rounded-t-lg"
          imageData={mobileImage}
          alt={mobileImage?.fields.altText}
          height={400}
          width={600}
        />
      </div>
      <div
        className={classNames('hidden lg:block lg:w-1/2', {
          'lg:w-full': isSingleItem,
        })}
      >
        {/* Desktop image */}
        <LuvImage
          className="w-full h-full rounded-l-lg object-cover"
          imageData={isSingleItem ? mobileImage : desktopImage}
          alt={desktopImage?.fields.altText}
          height={400}
          width={600}
        />
      </div>
      <div
        className={classNames(
          'bg-off-white flex flex-col rounded-b-lg lg:rounded-b-none lg:!rounded-r-lg lg:w-1/2 px-8 py-6 lg:pt-20 lg:pb-32',
          {
            'lg:w-full lg:!pt-0 lg:flex lg:flex-col lg:justify-center lg:items-start pl-[43px] pr-[62px]':
              isSingleItem,
          },
        )}
      >
        {badge && <Badge {...badge.fields} />}
        <Heading
          tag={HeadingTag.H3}
          size={HeadingSize.H3}
          classes="mt-2 lg:mt-4"
          align="left"
          text={title}
          hoverEffect
        />
        <p
          className={classNames(
            'mt-2 leading-6 text-lg text-charcoal lg:mt-2 text-left',
            {
              '!text-base lg:!mt-2': isSingleItem,
            },
          )}
        >
          {description}
        </p>
      </div>
    </div>
  );
};

export default SideImageCard;
